// src/hooks/usePermissionSocket.js
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  syncPermissionsFromWS,
  updatePermissionFromWS,
} from "store/slices/permissionSlice";
import voice from "assets/voice/notifcation.mp3";

const usePermissionSocket = () => {
  const dispatch = useDispatch();
  const user = useSelector((s) => s.auth.user);
  const token = useSelector((s) => s.auth.token);

  const socketRef = useRef(null);
  const reconnectTimeoutRef = useRef(null);
  const soundRef = useRef(new Audio(voice));

  const API_SOCKET_URL = process.env.REACT_APP_SOCKET_BASE_URL;

  soundRef.current.volume = 0.8;

  const isSoundEnabled = () =>
    localStorage.getItem("notificationSoundEnabled") !== "false";

  const playPermissionSound = () => {
    if (isSoundEnabled()) {
      soundRef.current.currentTime = 0;
      soundRef.current.play().catch(() => {});
    }
  };

  useEffect(() => {
    if (!user?.id || !token) {
      if (socketRef.current) {
        socketRef.current.close();
        socketRef.current = null;
      }
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
        reconnectTimeoutRef.current = null;
      }
      return;
    }

    const wsUrl = `${API_SOCKET_URL}/permissions/?token=${token}`;
    let shouldReconnect = true;

    const connect = () => {
      if (!shouldReconnect) return;

      const socket = new WebSocket(wsUrl);
      socketRef.current = socket;

      socket.onopen = () => {
        console.log("Permission WebSocket connected");
      };

      // socket.onmessage = (e) => {
      //   try {
      //     const data = JSON.parse(e.data);

      //     if (data.type === "initial_permissions") {
      //       dispatch(syncPermissionsFromWS(data.permissions));
      //     }

      //     if (data.type === "permission_changed" && data.action === "update") {
      //       dispatch(updatePermissionFromWS(data.permission));
      //       playPermissionSound();
      //     }
      //   } catch (err) {
      //     console.error("Permission WS parse error:", err);
      //   }
      // };


      socket.onmessage = (e) => {
  try {
    const data = JSON.parse(e.data);

    if (data.type === "initial_permissions") {
      dispatch(syncPermissionsFromWS(data.permissions));
    }

    if (data.type === "permission_changed") {
      if (data.action === "update") {
        dispatch(updatePermissionFromWS(data.permission));
        playPermissionSound();
      }

      // NEW: Handle deletion
      if (data.action === "delete") {
       dispatch(updatePermissionFromWS(data.permission));
        playPermissionSound(); // Optional: play sound on revoke too
      }

      // Optional: Handle "create" if backend sends it
      if (data.action === "create") {
        dispatch(updatePermissionFromWS(data.permission));
        playPermissionSound();
      }
    }
  } catch (err) {
    console.error("Permission WS parse error:", err);
  }
};

      socket.onclose = () => {
        console.log("Permission WS closed");
        socketRef.current = null;

        if (shouldReconnect) {
          console.log("Reconnecting permission socket in 3s...");
          reconnectTimeoutRef.current = setTimeout(connect, 3000);
        }
      };

      socket.onerror = (err) => {
        console.error("Permission WS error:", err);
        socket.close();
      };
    };

    connect();

    // Listen for sound setting changes (from settings page or other tabs)
    const handleStorageChange = (e) => {
      if (e.key === "notificationSoundEnabled") {
        console.log(
          "Permission sound setting →",
          isSoundEnabled() ? "ON" : "OFF"
        );
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      shouldReconnect = false;

      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
        reconnectTimeoutRef.current = null;
      }

      if (socketRef.current) {
        socketRef.current.close();
        socketRef.current = null;
      }

      window.removeEventListener("storage", handleStorageChange);
    };
  }, [user?.id, token, dispatch]);
};

export default usePermissionSocket;
